import { AtomicContext } from '@contexts/coveo/AtomicContext';
import {
  buildUrlManager,
  loadSearchActions,
  loadSearchAnalyticsActions,
} from '@coveo/atomic-react';
import { useSearchParams } from 'next/navigation';
import { useContext, useEffect, useRef, useState } from 'react';

export const useUrlManager = (context: AtomicContext) => {
  const { searchEngine } = useContext(context);
  const currentHash = useRef(window.location.hash.slice(1));
  const [urlManagerController] = useState(
    buildUrlManager(searchEngine!, {
      initialState: { fragment: window.location.hash.slice(1) },
    })
  );
  const [urlManagerState, setUrlManagerState] = useState(
    urlManagerController?.state
  );
  const searchParams = useSearchParams();

  // watches the URL for manual changes (like a Link) and synchronizes with coveo controller
  useEffect(() => {
    const hash = window.location.hash.slice(1);

    // don't synchronize on first render, only when hash actually changes
    if (currentHash.current !== hash) {
      urlManagerController.synchronize(hash);
      const analyticsAction = loadSearchAnalyticsActions(
        searchEngine!
      ).logSearchFromLink();
      const action = loadSearchActions(searchEngine!).executeSearch(
        analyticsAction
      );
      searchEngine!.dispatch(action);
      currentHash.current = hash;
    }
  }, [searchParams]);

  useEffect(() => {
    setUrlManagerState({ fragment: window.location.hash.slice(1) });

    const unsubscribeManager = urlManagerController?.subscribe(() => {
      setUrlManagerState(urlManagerController.state);
      currentHash.current = urlManagerController.state.fragment;
    });

    return () => {
      unsubscribeManager();
    };
  }, [urlManagerController]);

  return {
    urlManagerState,
  };
};
